module.exports = __webpack_public_path__ + "static/img/bg-overview@w.53f3d4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ipark-duty-free/bg-overview@w.jpg
// module id = Isqq
// module chunks = 0